import { render } from "./UserAvatarSettings.vue?vue&type=template&id=a6aad1a6"
import script from "./UserAvatarSettings.vue?vue&type=script&lang=js"
export * from "./UserAvatarSettings.vue?vue&type=script&lang=js"

import "./UserAvatarSettings.vue?vue&type=style&index=0&id=a6aad1a6&lang=scss"

import exportComponent from "/Users/gardener/OpenideProjects/Navigator_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__